var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemperatureSensor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 19V31C19 33.209 20.791 35 23 35C25.209 35 27 33.209 27 31V19H19Z",
    fill: "#EE8003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30C20.8783 30 18.8434 30.8429 17.3431 32.3431C15.8429 33.8434 15 35.8783 15 38C15 40.1217 15.8429 42.1566 17.3431 43.6569C18.8434 45.1571 20.8783 46 23 46C25.1217 46 27.1566 45.1571 28.6569 43.6569C30.1571 42.1566 31 40.1217 31 38C31 35.8783 30.1571 33.8434 28.6569 32.3431C27.1566 30.8429 25.1217 30 23 30Z",
    fill: "#EE8003"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 19H33V21H29V19ZM29 23H33V25H29V23ZM29 27H33V29H29V27Z",
    fill: "#B4B4B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 19V6C27 3.791 25.209 2 23 2C20.791 2 19 3.791 19 6V19H27Z",
    fill: "#CFD8DC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 15H33V17H29V15ZM29 11H33V13H29V11ZM29 7H33V9H29V7Z",
    fill: "#EE8003"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureSensor);
export default __webpack_public_path__ + "static/media/temperature-sensor.6348321f0b81ecee44d6601161ce4312.svg";
export { ForwardRef as ReactComponent };